<template>
  <v-container v-if="artist">
    <page-header :title="artist.artist"/>
    <v-container grid-list-md :class="['pa-0']">
      <v-layout row wrap>
        <v-flex d-flex lg6 xs12>
          <v-card>
            <div hidden v-html="artist.artist" :class="['meta-description']" />
            <v-img v-if="artist.photo && !artist.photo.includes('undefined')" :src="artist.photo" :alt="artist.photo" :title="artist.artist" />
          </v-card>
        </v-flex>
        <v-flex d-flex lg6 xs12>
          <v-card>
            <v-card-text>
              <v-container :class="['pa-0', 'mt-2']">
                <h3 v-html="lang.bandsParticipation" :class="['title', 'font-weight-light']" />
                <v-list two-line dense :class="['mt-2']">
                  <template v-for="(band, index) in artist.bands">
                    <v-list-tile ripple :key="index" :to="`/bands/${band.id}`" :title="lang.viewMoreInfo(band.name)">
                      <v-list-tile-action>
                        <v-icon>mdi-guitar-electric</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title :class="['wrap']" v-html="band.name" />
                        <v-list-tile-sub-title :class="['wrap']" v-html="band.instruments" />
                      </v-list-tile-content>
                      <chevron-right />
                    </v-list-tile>
                    <v-divider inset :key="index + '-divider'" v-if="index < artist.bands.length - 1" />
                  </template>
                </v-list>
              </v-container>
              <v-container :class="['pa-0', 'mt-2']">
                <h3 v-html="lang.discography" :class="['title', 'font-weight-light']" />
                <v-list two-line dense :class="['mt-2']">
                  <template v-for="(album, index) in artist.discography">
                    <v-list-tile ripple :key="index" :to="`/albums/${album.id}`" :title="lang.viewMoreInfo(album.title)">
                      <v-list-tile-action>
                        <v-icon>mdi-disk</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title :class="['wrap']" v-html="album.title" />
                        <v-list-tile-sub-title :class="['wrap']" v-html="album.year" />
                      </v-list-tile-content>
                      <chevron-right />
                    </v-list-tile>
                    <v-divider inset :key="index + '-divider'" v-if="index < artist.discography.length - 1" />
                  </template>
                </v-list>
                <warning :message="lang.recordsNotFound(lang.discography)" v-if="!artist.discography.length" />
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>
<script>
import lang from '../helpers/lang'
import methods from '../helpers/methods'

export default {
  name: 'artists-id',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      id: null,
      artist: null
    }
  },
  watch: {
    /**
     * route.params.id watcher
     */
    '$route.params.id' () {
      this.onMounted()
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Mounted event handler
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      this.id = this.$route.params.id
      const cache = this.getCachedPage('artists', this.id)
      cache ? this.done(cache) : this.getArtistData()
    },
    /**
     * Get the page data from the API
     * @method getArtistData
     * @return {void}
     */
    getArtistData () {
      const url = this.$root.routes.find(route => route.url.includes('artists/:')).url.replace(':id', this.id)
      this.$http(url)
        .then(response => {
          this.done(response.data.payload)
        })
    },
    /**
     * Process the data from API or from the cache
     * @method done
     * @param {object} response [response=null]
     * @return {void}
     */
    done (response = null) {
      this.artist = response
      this.$nextTick(() => {
        this.emitRouteChange()
        this.$nextTick(() => {
          this.setLastBreadcrumbsItemText(this.artist.artist)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/artists-id.vue